export default __webpack_public_path__ + "static/media/icebreakers.0df17c54.svg";